import { render, staticRenderFns } from "./NewMain.vue?vue&type=template&id=4b03d89d&scoped=true&"
import script from "./NewMain.vue?vue&type=script&lang=js&"
export * from "./NewMain.vue?vue&type=script&lang=js&"
import style0 from "./NewMain.vue?vue&type=style&index=0&id=4b03d89d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b03d89d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_dev\\workspace_front\\aikl_v2_front_kcc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b03d89d')) {
      api.createRecord('4b03d89d', component.options)
    } else {
      api.reload('4b03d89d', component.options)
    }
    module.hot.accept("./NewMain.vue?vue&type=template&id=4b03d89d&scoped=true&", function () {
      api.rerender('4b03d89d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/NewMain.vue"
export default component.exports